/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SmsParameterPlace = {
    Query: 'QUERY',
    Header: 'HEADER',
    JsonBody: 'JSON_BODY',
    Path: 'PATH',
    FormBody: 'FORM_BODY'
} as const;
export type SmsParameterPlace = typeof SmsParameterPlace[keyof typeof SmsParameterPlace];


export function instanceOfSmsParameterPlace(value: any): boolean {
    for (const key in SmsParameterPlace) {
        if (Object.prototype.hasOwnProperty.call(SmsParameterPlace, key)) {
            if (SmsParameterPlace[key as keyof typeof SmsParameterPlace] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SmsParameterPlaceFromJSON(json: any): SmsParameterPlace {
    return SmsParameterPlaceFromJSONTyped(json, false);
}

export function SmsParameterPlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsParameterPlace {
    return json as SmsParameterPlace;
}

export function SmsParameterPlaceToJSON(value?: SmsParameterPlace | null): any {
    return value as any;
}

export function SmsParameterPlaceToJSONTyped(value: any, ignoreDiscriminator: boolean): SmsParameterPlace {
    return value as SmsParameterPlace;
}

